<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-29 15:23:28
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-29 15:25:42
 * @name: 欢迎页
 * @Description: 欢迎页
 * @FilePath: \preSaleNafterSaleBackstage\src\views\welcome\welcome.vue
 * @Author: desktop
-->
<template>
  <div class="welcome">
    欢迎使用售前售后管理系统
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.welcome {
  width: 100%;
  height: 100%;
  @extend .extend-flex-center;
  font-size: 32px;
}
</style>